import { useDispatch } from 'react-redux'

import { AppDispatch } from '../redux/stores/store'

export const useAppDispatch = () => useDispatch<AppDispatch>()
